// src/pages/CompanyDefaults/components/CompanyDefaultsForm.jsx
import React, { useState, useEffect, useCallback } from "react";
import useCompanyDefaultsModal from "../hooks/useCompanyDefaultsModal";
import CompanyDefaultsSideFormInline from "./CompanyDefaultsSideForm"; // Corrected import path

// Import your table components (ensure paths are correct)
import PostingAccountsTable from "./Actions/PostingAccounts/PostingAccountsTable";
import InvoiceSetupTable from "./Actions/InvoicingSetup/InvoiceSetupTable";
import UserSecurityTable from "./Actions/UserSecurity/UserSecurityTable";
import AccountUtilitiesTable from "./Actions/EmailNotifications/EmailAlertsTable"; 


export default function CompanyDefaultsForm({ feature, setFeature }) {
  const {
    formData,
    setFormData,
    isEditing,
    setIsEditing,
    id,
    setId, // Get setId to potentially update after create
    handleLookup,
    prepareNewItem,
    createItem,
    editItem,
    handleDelete,
    companyList,
    fetchCompanyList, // Get non-memoized version is fine here
    isLoadingList,
    isLoadingDetails,
    handleChange, // Get handleChange from hook
  } = useCompanyDefaultsModal();

  // Fetch company list only once on mount
  useEffect(() => {
    console.log("CompanyDefaultsForm: Fetching company list on mount.");
    fetchCompanyList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once

  // Initial load effect for record #1 (If desired, otherwise remove)
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    // Load record 1 only if no ID is currently set (e.g., after delete or initial load)
    if (!initialized && id === null) {
      console.log("CompanyDefaultsForm: Initializing and loading default record '1'");
      handleLookup("1"); // Load default record '1'
      setInitialized(true);
    }
  }, [initialized, id, handleLookup]);


  // Handler for when a company is selected from the list component
  const handleCompanySelect = useCallback((selectedId) => {
    if (isEditing) {
        alert("Please save or cancel current changes before switching records.");
        return;
    }
    if (selectedId && selectedId !== id) {
      console.log(`Company selected: ID=${selectedId}. Loading details...`);
      handleLookup(selectedId); // Trigger lookup (updates id, formData, isEditing in hook)
      setFeature(null); // Close right panel feature view
    } else if (selectedId === id) {
        console.log("Selection ignored - same ID already loaded.");
        setFeature(null); // Still close list view if they click current
    } else {
        console.log("Selection ignored - invalid ID.");
    }
  }, [isEditing, id, handleLookup, setFeature]); // Dependencies for the handler


  // *** Table Definitions are HERE in the Parent ***
  const tableById = {
    PostingAccounts: <PostingAccountsTable />,
    InvoicingSetup: <InvoiceSetupTable />,
    UserSecurity: <UserSecurityTable />,
    EmailNotifications: <AccountUtilitiesTable />,
  };

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Pass down all necessary state and handlers */}
      <CompanyDefaultsSideFormInline
        // Feature state
        feature={feature}
        setFeature={setFeature}
        // Table Definitions (Passed Down)
        tableById={tableById}
        // Edit State & Form Data
        isEditing={isEditing}
        setIsEditing={setIsEditing} // Pass setter down
        data={formData}
        setData={setFormData} // Pass setter down
        id={id}
        setId={setId} // Pass down in case needed after create
        // CRUD Handlers
        onPrepareNew={prepareNewItem}
        onCreate={createItem}
        onSave={editItem} // Pass editItem as onSave
        onDelete={handleDelete}
        onFieldChange={handleChange} // Pass down field change handler
        // Company List related props
        companyList={companyList}
        onCompanySelect={handleCompanySelect}
        // Loading states
        isLoadingList={isLoadingList}
        isLoadingDetails={isLoadingDetails}
      />
    </div>
  );
}